<script setup lang="ts">
import { computed, ref } from 'vue';
import { Input } from '@/components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CheckIcon } from '@heroicons/vue/24/solid';

const props = defineProps<{
  field: string;
  dataType: string;
  data: any;
  classType: string;
}>();

const filterText = ref('');

// Get the children array data
// Field pattern: 'bucket_genres.display_string' where 'bucket_genres' is the array field
const childrenArray = computed(() => {
  const parts = props.field.split('.');
  if (parts.length !== 2 || parts[1] !== 'display_string') {
    return [];
  }
  const arrayField = parts[0];
  const arrayData = props.data[arrayField];
  return Array.isArray(arrayData) ? arrayData : [];
});

// Filter items based on filter text (searches genre name)
const filteredItems = computed(() => {
  if (!filterText.value.trim()) {
    return childrenArray.value;
  }
  const searchText = filterText.value.toLowerCase();
  return childrenArray.value.filter((item: any) => {
    const genreName = item?.genre?.display_string || item?.genre?.name || '';
    return genreName.toLowerCase().includes(searchText);
  });
});
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
    <!-- Filter section with input -->
    <div class="py-3 border-b px-4">
      <Input
        v-model="filterText"
        placeholder="Filter genres..."
      />
    </div>
    <!-- Scrollable table -->
    <div class="flex-1 min-h-0 overflow-y-auto px-4">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead class="w-auto">Genre</TableHead>
            <TableHead class="w-20">Weight</TableHead>
            <TableHead class="w-20">Dynamic</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <template v-if="filteredItems.length > 0">
            <TableRow
              v-for="(item, index) in filteredItems"
              :key="index"
            >
              <TableCell>
                {{ item?.genre?.display_string || item?.genre?.name || '—' }}
              </TableCell>
              <TableCell class="w-20">
                {{ item?.bucket_weight ?? '—' }}
              </TableCell>
              <TableCell class="w-20 text-center">
                <CheckIcon
                  v-if="item?.is_dynamic"
                  class="h-4 w-4 text-primary mx-auto"
                />
                <span v-else class="text-muted-foreground">—</span>
              </TableCell>
            </TableRow>
          </template>
          <TableRow v-else>
            <TableCell colspan="3" class="text-center text-muted-foreground py-6">
              No items found
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  </div>
</template>
